export default __webpack_public_path__ + "static/media/1536.6e7ef0c5.png";